import { ListViewBody, ListViewLabel } from '@/components/ListView';
import { ApprovalStep } from '@/features/approving_invoice_reports/components/ApprovalRouteDrawer/components/ApprovalStep';
import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import {
  ListViewBody as ApListViewBody,
  IconHelp,
  Loading,
  Tooltip,
  Top,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, Suspense } from 'react';
import { useApprovalRoute } from '../hooks/useApprovalRoute';
import { ContentsProps } from '../types';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export const InnerContents: FC<ContentsProps> = ({
  reportId,
  onCloseDetailDrawer,
}) => {
  const container = useGlobalContainerRef();
  const { data } = useApprovalRoute({ reportId, onCloseDetailDrawer });
  const { t } = useTranslation();
  return (
    <div className={cx('container')}>
      <ApListViewBody className={cx('list-view-body')}>
        <Top>
          <ListViewLabel>
            <div className={cx('label-container')}>
              <span>{t('approving_invoice_reports.approval_route')}</span>
              <Tooltip
                title={t('approving_invoice_reports.approval_route.tooltip')}
                getPopupContainer={container}
                overlayClassName={cx('tooltip-container')}
              >
                <span>
                  <IconHelp size={14} />{' '}
                </span>
              </Tooltip>
            </div>
          </ListViewLabel>
          <ListViewBody>{data?.workflow_route?.name}</ListViewBody>
        </Top>
        {data?.steps &&
          data.steps?.map((step) => (
            <ApprovalStep key={step.name} step={step} />
          ))}
      </ApListViewBody>
    </div>
  );
};

const FallBackLoading = () => {
  return (
    <div className={cx('loading-container')}>
      <Loading size='large' color='default' />
    </div>
  );
};

export const Contents: FC<ContentsProps> = memo((props) => {
  return (
    <Suspense fallback={<FallBackLoading />}>
      <InnerContents {...props} />
    </Suspense>
  );
});
Contents.displayName = 'Contents';
